import { apiClient, apiRequest } from '@/lib/api/client';
import type { ApiResult } from '@/lib/api/types';
import type {
  CreateInvitePayload,
  InviteSignupPayload,
  InviteValidation,
  PendingInvite,
  TeamMember,
  UpdateUserRolePayload,
} from '@/types/team';
import type { AuthResponse } from '@/types/user';

export async function getTeamMembers(): Promise<ApiResult<TeamMember[]>> {
  return apiRequest(() => apiClient.get<TeamMember[]>('/auth/users'));
}

export async function getPendingInvites(): Promise<ApiResult<PendingInvite[]>> {
  return apiRequest(() => apiClient.get<PendingInvite[]>('/auth/invites'));
}

export async function createInvite(
  payload: CreateInvitePayload
): Promise<ApiResult<{ message: string; inviteId: string }>> {
  return apiRequest(() =>
    apiClient.post<{ message: string; inviteId: string }>(
      '/auth/invite',
      payload
    )
  );
}

export async function revokeInvite(
  inviteId: string
): Promise<ApiResult<{ message: string }>> {
  return apiRequest(() =>
    apiClient.delete<{ message: string }>(`/auth/invite/${inviteId}`)
  );
}

export async function validateInviteToken(
  token: string
): Promise<ApiResult<InviteValidation>> {
  return apiRequest(() =>
    apiClient.get<InviteValidation>(`/auth/invite/validate/${token}`)
  );
}

export async function signupWithInvite(
  payload: InviteSignupPayload
): Promise<ApiResult<AuthResponse>> {
  return apiRequest(() =>
    apiClient.post<AuthResponse>('/auth/signup-with-invite', payload)
  );
}

export async function updateUserRole(
  userId: string,
  payload: UpdateUserRolePayload
): Promise<ApiResult<{ message: string }>> {
  return apiRequest(() =>
    apiClient.put<{ message: string }>(`/auth/users/${userId}/role`, payload)
  );
}
